import React, { useState } from "react";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

import "./stylesAllSportsPopup.css";
import { Save, X } from "react-feather";

import SaveButton from "../../CommonComponents/SaveButton/SaveButton";
import TextEdit from "../../../assets/icons/ic_text-edit.svg";

function AllSportsPopup({ isVisible, onClosePressed, getEventCodesList }) {
  const token = JSON.parse(localStorage.getItem("token"));
  const email = JSON.parse(localStorage.getItem("email"));

  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const maxChars = 50; // Máximo de caracteres permitidos

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    console.log("comment", comment);

    return;
  };

  const handleClosePressed = () => {
    onClosePressed();
    setComment("");
  };

  const handleSetComment = (value) => {
    if (value.length <= maxChars) {
      setComment(value);
    }
  };

  if (!isVisible) return null;
  return (
    <div className="all-sports-popup">
      <div className="all-sports-panel">
        <div className="all-sports-panel-header">
          <h2>HTML Editor</h2>
          <button className="close-button" onClick={handleClosePressed}>
            <X className="close-icon" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="event-code-input">
            <div className="html-editor-icons">
              <img src={TextEdit} alt="" />
              <img src={TextEdit} alt="" />
              <div className="divider"></div>
              <img src={TextEdit} alt="" />
              <img src={TextEdit} alt="" />
              <div className="divider"></div>
              <img src={TextEdit} alt="" />
              <img src={TextEdit} alt="" />
            </div>
            <textarea
              id="eventCode"
              value={comment}
              placeholder="Leave a comment"
              onChange={(e) => handleSetComment(e.target.value)}
              rows="8"
              required
            />
            <div className="comment-counter">
              {comment.length}/{maxChars}
            </div>
          </div>
          <SaveButton
            isSubmitting={isSubmitting}
            buttonText="Add Code"
            cancelButton={true}
            cancelButtonText="Cancel"
            callbackFunction={handleSubmit}
            callbackFunctionCancel={handleClosePressed}
          />
        </form>
      </div>
    </div>
  );
}

export default AllSportsPopup;
